import { Outlet } from "react-router-dom";
import Header from "../components/Header/index";
import Footer from "../components/Footer/index";
import PageTitleBar from "../components/PageTitleBar";

export default function RootLayout() {
  return (
    <div className="min-h-screen flex flex-col overflow-x-hidden bg-[#f0f0f5]">
      <Header />
      <PageTitleBar />
      <main className="flex-1 w-full min-w-0 px-4 pb-6">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}